import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

export const i18nConfig = {
  debug: process.env.NODE_ENV !== 'production',
  ns: ['translations', 'consultation-form', 'landings-info'],
  fallbackLng: 'ru',
  returnEmptyString: false,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
};

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init(i18nConfig);
}

export default i18n;
